<router-outlet (deactivate)="onDeactivate()"></router-outlet>
<ngx-spinner bdColor = "rgba(0,0,0,0.5)" type="ball-scale-multiple" [fullScreen]="true"></ngx-spinner>